export default __webpack_public_path__ + "static/media/pointing.08563f59.svg";